module.exports = __webpack_public_path__ + "static/img/ku-prime.5b4cce8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/ku-prime.jpg
// module id = K9MF
// module chunks = 0